import React, {ReactNode} from 'react';

import ListActions from 'shared/ui/ListPage/ListActions/ListActions';
import MainModal from 'shared/ui/Modal/MainModal';
import MassOperations, {IMassOperationAction} from 'shared/ui/MassOperations/MassOperations';

import {IMonitorListState} from '../../model/useMonitorList';

export interface IBatchFormProps {
    action?: IMassOperationAction,
    onSuccess: () => void,
    handleClose: () => void,
}

interface IMassOperationsBlockProps {
    list: IMonitorListState,
    actions: IMassOperationAction[],
    getHeader: (_actionValue?: string) => string,
    renderForm: (_props: IBatchFormProps) => ReactNode,
    children?: ReactNode,
}

const MassOperationsBlock: React.FC<IMassOperationsBlockProps> = ({
    list,
    actions,
    getHeader,
    renderForm,
    children,
}) => (
    <ListActions>
        <MassOperations
            count={list.selectedCount}
            actions={actions}
            onClear={list.clearSelection}
            toggleMassOperationsMode={list.toggleMassOperationsMode}
            onClose={list.exitMassOperationsMode}
            renderModal={({open, action, handleClose, onSuccess}) => (
                <MainModal
                    header={getHeader(action?.value)}
                    open={open}
                    handleClose={handleClose}
                    size="md"
                >
                    {renderForm({action, onSuccess, handleClose})}
                </MainModal>
            )}
        />
        {children}
    </ListActions>
);

export default MassOperationsBlock;
